<template>
	<div v-if="reason">
		<div class="text-lg font-bold text-red-500">
			{{ reason }}
		</div>
		<div v-if="path">
			<a :href="`https://www.asiago.it${path}#content-start`" class="underline text-blue-500">
				Visualizza l'evento aggiornato
			</a>
		</div>
		<n-divider class="!my-4 !w-auto" />
	</div>
</template>

<script setup>
	import {Directus} from '@directus/sdk'
	import {NDivider} from 'naive-ui'

	const directus = new Directus('https://cms.asiago.it')
	const props = defineProps({
		articleId: {
			type: Number,
			required: true,
		},
	})
	const data = await directus.items('NotiziaArticoli').readOne(props.articleId, {
		fields: [
			'cancel_postpone_event_new_article_id.translations.ArticleUrl',
			'translations.cancel_postpone_event_reason',
		],
		deep: {
			translations: {_filter: {IdLingua: {id: {_eq: 1}}}},
			cancel_postpone_event_new_article_id: {
				translations: {_filter: {IdLingua: {id: {_eq: 1}}}},
			},
		},
	})

	const reason = data?.translations?.[0]?.cancel_postpone_event_reason
	const path = data?.cancel_postpone_event_new_article_id?.translations?.[0]?.ArticleUrl
</script>
